import type { RoadmapItemStatus } from "@/services/api/types";
import type { DefaultTheme } from "styled-components";

export const statusDescriptions: Record<RoadmapItemStatus, string> = {
  discovery: "Defining the problem, engaging stakeholders and considering the options",
  shaping: "Defining the solution – what’s in and out of scope",
  in_progress: "Build is underway",
  paused: "Work has paused due to unforeseen issues or reprioritisation",
  in_staging: "Item is available for testing and feedback",
  done: "Item is live in production",
};

export const getRoadmapStatusDot = (
  theme: DefaultTheme,
  status: RoadmapItemStatus
) => {
  switch (status) {
    case "discovery":
      return theme.colors.highlight2;
    case "shaping":
      return theme.colors.accent2;
    case "in_progress":
      return theme.colors.highlight1;
    case "paused":
      return theme.colors.error;
    case "in_staging":
      return "#FAB03A";
    case "done":
      return theme.colors.highlight3;
    default:
      return theme.colors.dark;
  }
};

export const getRoadmapStatusBg = (status: RoadmapItemStatus) => {
  switch (status) {
    case "discovery":
      return "#F3FBFE";
    case "shaping":
      return "#E5F1F6";
    case "in_progress":
      return "#F5ECF6";
    case "paused":
      return "#FDECEC";
    case "in_staging":
      return "#FCF2E3";
    case "done":
      return "#EBF9EA";
    default:
      return "#E8E7EB";
  }
};
